import * as React from "react";
import { PropTypes } from "prop-types";
import { createEncodedKey } from "../../../utils/helpers";
import { ProductEducationAccordions } from "../../why-we-made-this/product-education-accordions/product-education-accordions";

import "./product-education-summary.scss";

function ProductEducationSummary({
  currentBreakpoint,
  designedFor,
  materialAndCare,
  productEducationAttributes
}) {
  return (
    <div className="product-education-summary">
      <ul className="product-education-summary__feature-list">
        {designedFor && (
          <li className="product-education-summary__feature-list--item">
            {designedFor}
          </li>
        )}
        {productEducationAttributes.map((productAttributeText) => (
          <li
            key={createEncodedKey(
              `product-edu-feature-list-item--${productAttributeText}`
            )}
            className="product-education-summary__feature-list--item"
          >
            {productAttributeText}
          </li>
        ))}
      </ul>
      <ProductEducationAccordions
        currentBreakpoint={currentBreakpoint}
        materialAndCare={materialAndCare}
        size="small"
      />
    </div>
  );
}

ProductEducationSummary.defaultProps = {
  materialAndCare: {},
  designedFor: ""
};

ProductEducationSummary.propTypes = {
  currentBreakpoint: PropTypes.string.isRequired,
  designedFor: PropTypes.string,
  materialAndCare: PropTypes.shape({
    iconId: PropTypes.string,
    id: PropTypes.string,
    sections: PropTypes.array,
    title: PropTypes.string
  }),
  productEducation: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ProductEducationSummary;
